/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {MaterialDetailContract} from '../../../api/ms-partnumberchanges/contracts/material-detail/material-detail.contract';
import {MaterialDetailModel} from './material-detail.model';

export class MaterialDetailMapper {
    private constructor() {
    }

    static fromMaterialDetailContract(input: MaterialDetailContract): MaterialDetailModel {
        let model: MaterialDetailModel = null;

        if (input != null) {
            model = {
                supplyingPackingPlantCode: input.supplyingPackingPlantCode,
                number: input.number,
                salesUnit: input.salesUnit,
                description: input.description,
                active: input.active
            };
        }
        return model;
    }

    static fromMaterialDetailContractArray(input: MaterialDetailContract[]): MaterialDetailModel[] {
        return input?.map(MaterialDetailMapper.fromMaterialDetailContract);
    }

}
